import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";

const JustificarInasistencia = ({ inasistencia, cadete, actualiza }) => {
  const [descripcion, setDescripcion] = useState("");
  const Usuario = ObtieneDatosCookies();

  const handleJustificar = async (e) => {
    e.preventDefault();

    // ✅ Verificar si ya tiene observación
    if (inasistencia.observacion) {
      const confirm = await Swal.fire({
        title: "Advertencia",
        text: `Esta inasistencia ya fue justificada. Observación previa: "${inasistencia.observacion}". ¿Desea agregar una nueva justificación?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
      });

      if (!confirm.isConfirmed) return;
    }
const sedeOperador=Usuario.sedeID==2?"Rosario":"Recreo"
 
    if (sedeOperador !== cadete.cadeteSede && Usuario.destino != 7 ||sedeOperador !== cadete.cadeteSede && !comprueboPermisos(Usuario.funcion,"Justifica Inasistencia") ) {
      Swal.fire({
        icon: "warning",
        title: "Acceso denegado",
        text: "No puede justificar una inasistencia de un cadete de otra sede.",
      });
      return;
    }

   
    const confirmFinal = await Swal.fire({
      title: "¿Está seguro?",
      text: "¿Desea justificar esta inasistencia?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, justificar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmFinal.isConfirmed) return;

    try {
      const username = process.env.REACT_APP_KEY;
      const password = process.env.REACT_APP_PASS;
      const token = btoa(`${username}:${password}`);

      const opartor = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/JustificaInasistencia",
        {
          id: inasistencia.id,
          observacion:
            descripcion +
            " (Usuario Cargo: " +
            Usuario.nombre +
            " " +
            Usuario.apellido +
            " de " +
            Usuario.dependenciaNombre +
            " en fecha: " +
            new Date().toLocaleString() +
            ")",
          justificada: "Si",
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (opartor) {
        Swal.fire({
          icon: "success",
          title: "Justificación enviada",
          text: "Inasistencia justificada correctamente.",
        });

        const Usuarios = {
          userID: Usuario.identificacion,
          cadeteDni: cadete.cadeteDni,
          Operacion: `Se justificó inasistencia de fecha: ${inasistencia.fecha}`,
        };

       const proceso= await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/registrarLog",
          {
            Usuario: Usuarios,
          },
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        );
        if(proceso){
          actualiza()
        }
      }

      setDescripcion("");

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo justificar la inasistencia.",
      });
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleJustificar}>
      <div className="card shadow">
        <div className="card-body">
          <h5 className="card-title">
            Justificar Inasistencia de {cadete.cadeteApellido}, {cadete.cadeteNombre}
          </h5>
          <div className="mb-3">
            <textarea
              id="descripcion"
              className="form-control"
              rows="4"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Ingrese la justificación aquí..."
              required
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary">
            Justificar
          </button>
        </div>
      </div>
    </form>
  );
};

export default JustificarInasistencia;
